import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tyt-plus-unlocked',
  templateUrl: './plus-unlocked.component.html',
  styleUrls: ['./plus-unlocked.component.scss']
})
export class PlusUnlockedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
